import { toWheelPosition, type PrimitiveWheelLayout } from '@/adapters/primitive/_pure/derivation/wheels';
import type { NaturalReceiverLocation } from '@/adapters/primitive/_contract/natural/location';
import type { Config } from '@/adapters/primitive/_contract/config';

export function toNaturalReceiverLocationPosition(args: {
    config: Config;
    layout: PrimitiveWheelLayout;
    location: NaturalReceiverLocation;
    sourcePosition?: readonly [number, number, number];
}): [number, number, number] {
    if (args.location.locationKind === 'source') {
        if (args.sourcePosition === undefined) {
            throw new Error('A source position is required to project a source location.');
        }
        return [...args.sourcePosition];
    }

    const receiverPosition = toWheelPosition({
        layout: args.layout,
        role: args.location.receiverRole,
    });
    const { standoffNearOffset, standoffFarGap } = args.config.base.display.wheel;
    // Each ante is the midpoint of the two positions a settlement spans.
    const offset = {
        'standoff-far': standoffNearOffset + standoffFarGap,
        'standoff-far-ante': standoffNearOffset + standoffFarGap / 2,
        'standoff-near': standoffNearOffset,
        'standoff-near-ante': standoffNearOffset / 2,
        receiver: 0,
    }[args.location.locationKind];
    const direction = args.location.receiverRole === 'multiplier'
        || args.location.receiverRole === 'remaining-repetitions' ? -1 : 1;

    return [receiverPosition[0], receiverPosition[1], receiverPosition[2] + direction * offset];
}